import notFoundImg from '@assets/status-pages/not_found.webp';
import { useLingui } from '@lingui/react/macro';
import StatusPage from '@routes/system/___shared___/components/status-page';
import { Text } from '@routes/system/___shared___/components/status-page/styled.tsx';

const NoClient = () => {
    const { t } = useLingui();

    return (
        <StatusPage
            image={<img src={notFoundImg} alt={t`no client image`} />}
            header={''}
            subheader={t`Lost at Sea!`}
            content={
                <Text>
                    {t`The company URL you entered is incorrect.`} <br /> {t`Please check and try again.`}
                </Text>
            }
            showBackToHomeBtn={false}
            fetchClientData={false}
        />
    );
};

export default NoClient;
